<script setup lang="ts">
import { computed } from 'vue'

/**
 * Renders a Material Design Icon by name.
 *
 * The backend stores icon names in the same `mdi-*` form the webfont uses
 * (e.g. "mdi-view-dashboard"), so names coming from `GET /menu` work as-is.
 * A missing icon simply renders nothing rather than a broken glyph.
 */
const props = withDefaults(
  defineProps<{
    name?: string | null
    /** Used when `name` is empty — handy for menu entries without an icon. */
    fallback?: string | null
  }>(),
  { name: null, fallback: null },
)

const iconClass = computed<string | null>(() => {
  const raw = props.name?.trim() || props.fallback?.trim() || ''
  if (!raw) return null
  return raw.startsWith('mdi-') ? raw : `mdi-${raw}`
})
</script>

<template>
  <!-- Decorative by definition: the adjacent text carries the meaning. -->
  <span v-if="iconClass" class="mdi shrink-0" :class="iconClass" aria-hidden="true" />
</template>
